import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUserLoginHistory, getUserByNameOrNumber } from '../../actions/userLogActions';
import { Col, Form, Row, Button, Table } from 'react-bootstrap';
import Moment from 'react-moment';
import Pagination from '../subLevel/Pagination';
import LogDetails from '../Others/LogDetailsWORedux';
class UserLogs extends Component {
  constructor() {
    super();
    this.state = {
      searchValue: '',
      pageNo: 1,
      pageSize: 10,
      totalPages: null,
      logData: [],
      userData: {},
      viewDetails: false,
      viewDetailsDate: null,
      error: ''
    }
  }

  onChange = e => {
    this.setState({ [e.target.id]: e.target.value });
    let key = e.target.value;
    let page = this.state.page;
    if (e.target.value.length >= 1) {
      this.props.getUserByNameOrNumber({ key, page });
    }
  };

  onSubmit = e => {
    e.preventDefault();
  }



  getLogs(data) {
    this.setState({
      userData: data
    })
    let searchData = {
      pageNo: this.state.pageNo,
      pageSize: this.state.pageSize,
      user_id: data.user_id

    }

    this.props.getUserLoginHistory(searchData)
      .then(resp => {
        this.setState({
          logData: resp.result,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages
        })
      })
      .catch(err => {
        this.setState({ err: err })
      })
  }

  viewLogDetails = (id) => {
    this.setState({
      viewDetails: true,
      viewDetailsDate: id,
    })
  }

  backToListHandler = () => {
    this.setState({
      viewDetails: false,
      viewDetailsDate: null,
    })
  }

  switchPage = (searchData) => {
    searchData.user_id = this.state.userData._id
    this.props.getUserLoginHistory(searchData)
      .then(resp => {
        this.setState({
          logData: resp.result,
          pageNo: resp.pageNo,
          pageSize: resp.pageSize,
          totalPages: resp.totalPages
        })
      })
      .catch(err => {
        this.setState({ error: err })
      })
  }


  render() {
    let usersLogsList;
    let suggestions;

    if (this.state.logData.length > 0) {
      usersLogsList = this.state.logData.map((log) => (

        <tr key={log._id}>
          <td><Moment format="DD/MM/YYYY"> {log._id} </Moment></td>
          <td>{log.actions.length}</td>
          <td>
            <button onClick={() => this.viewLogDetails(log._id)}> View details</button>
          </td>
        </tr>
      ))
    } else {
      usersLogsList = <p> No data found</p>
    }

    if (this.props.userSuggestions) {
      suggestions = this.props.userSuggestions.map((item) => (
        <li style={{ cursor: 'pointer', color: 'blue' }} onClick={() => this.getLogs(item)}>{item.zvr_name} / {item.zvr_email} / {item.zvr_mobile_no}</li>
      ))
    }

    let filterOptions = <React.Fragment>
      <Col>
        <label>Name / Email / PhoneNumber </label>
        <input
          type='text'
          id='searchValue'
          onChange={this.onChange}
          value={this.state.searchValue}
        />
      </Col>
      <Col>
        <ul>
          {suggestions}
        </ul>
      </Col>
    </React.Fragment>

    if (this.state.viewDetails) {
      return <LogDetails Userlogs={this.state.logData} date={this.state.viewDetailsDate} goBackToListHandler={this.backToListHandler} />
    }

    return (
      <div>
        <h1>User logs</h1>

        <Form className="bg-red">
          <Row>
            <Col>
              {filterOptions}

            </Col>
          </Row>
        </Form>
        <hr />
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Date</th>
              <th>Sessions Count</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {usersLogsList}

          </tbody>
        </Table>
        {(this.state.logData.length > 0) ?
          <Pagination currentPage={this.state.pageNo}
            lastPage={this.state.totalPages}
            getInfo={this.switchPage}
          />
          : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  userLogs: state.logs.users,
  userSuggestions: state.logs.userSuggestions
})

export default connect(mapStateToProps, { getUserLoginHistory, getUserByNameOrNumber })(UserLogs);